const walletPositionTableColumns = [
  {
    name: "category",
    title: "Categoria",
    editable: false,
    width: 170,
  },
  {
    name: "className",
    title: "Classe",
    editable: false,
    width: 133,
  },
  {
    name: "subcategory",
    title: "Subclasse",
    editable: false,
  },
  // {
  //   name: "clientName",
  //   title: "Cliente",
  //   editable: false,
  //   width: 250,
  // },
  // {
  //   name: "assessorName",
  //   title: "Assessor responsável",
  //   editable: false,
  //   width: 170,
  // },
  {
    name: "broker",
    title: "Instituição",
    editable: false,
    width: 100,
  },
  {
    name: "amount",
    title: "Valor",
    editable: false,
    type: "brCurrency",
    width: 170,
  },
  {
    name: "liquidity",
    title: "Liquidez",
    editable: false,
    width: 110,
  },
  {
    name: "product",
    title: "Produto",
    editable: false,
    width: 270,
  },
  {
    name: "issuer",
    title: "Emissor",
    editable: false,
    width: 200,
  },
  {
    name: "code",
    title: "Código",
    editable: false,
    width: 170,
  },
  {
    name: "acquisitionDate",
    title: "Data de aquisição",
    editable: false,
    type: "date",
    width: 170,
  },
  {
    name: "indexer",
    title: "Indexador",
    editable: false,
    width: 170,
  },
  {
    name: "rate",
    title: "Taxa",
    editable: false,
    width: 170,
  },
  {
    name: "maturityDate",
    title: "Vencimento",
    editable: false,
    width: 170,
  },
  {
    name: "acquisitionQuantity",
    title: "Quantidade Adquirida",
    editable: false,
    width: 170,
  },
  {
    name: "acquisitionUnitPrice",
    title: "Preço Unitário de Aquisição",
    editable: false,
    type: "brCurrency",
    width: 170,
  },
  {
    name: "acquisitionPrice",
    title: "Valor de Aquisição",
    type: "brCurrency",
    editable: false,
    width: 170,
  },
  {
    name: "currentUnitPrice",
    title: "Preço Unitário Atual",
    type: "brCurrency",
    editable: false,
    width: 170,
  },
  {
    name: "grossValue",
    title: "Valor Bruto",
    type: "brCurrency",
    editable: false,
    width: 170,
  },
  {
    name: "incomeTax",
    title: "Imposto",
    type: "brCurrency",
    editable: false,
    width: 170,
  },
  {
    name: "iof",
    title: "IOF",
    editable: false,
    type: "brCurrency",
    width: 170,
  },
  {
    name: "netValue",
    title: "Valor Líquido",
    type: "brCurrency",
    editable: false,
    width: 170,
  },
  {
    name: "premium",
    title: "Ágio/Deságio",
    editable: false,
    type: "brCurrency",
    width: 170,
  },
  {
    name: "referenceDate",
    title: "Data de Referência",
    editable: false,
    type: "date",
    width: 170,
  },
  {
    name: "suggestedFund1Name",
    title: "1ª Sugestão de Fundo",
    width: 350,
    editable: false,
  },
  {
    name: "suggestedFund2Name",
    title: "2ª Sugestão de Fundo",
    width: 350,
    editable: false,
  },
  {
    name: "suggestedFund3Name",
    title: "3ª Sugestão de Fundo",
    width: 350,
    editable: false,
  },
];

const walletPositionTableLeftFixedColumns = [
  "category",
  "className",
  "subcategory",
];

const walletPositionTableSummaries = [
  { columnName: "amount", type: "brCurrencySum" },
  { columnName: "acquisitionPrice", type: "brCurrencySum" },
  { columnName: "grossValue", type: "brCurrencySum" },
  { columnName: "incomeTax", type: "brCurrencySum" },
  { columnName: "iof", type: "brCurrencySum" },
  { columnName: "netValue", type: "brCurrencySum" },
];

export { walletPositionTableLeftFixedColumns, walletPositionTableSummaries };
export default walletPositionTableColumns;
